export default {"src":"/_next/static/media/telegram.a6cf4d68.svg","height":240,"width":240};